module.exports = __webpack_public_path__ + "static/euphoros-2-5cfae61b209299dd9d4da66332990895.jpg";